var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" Closed changes for the selected reporting period "),_c('v-data-table',{attrs:{"loading":_vm.queryLoading,"headers":_vm.headers,"items":_vm.items,"hide-default-footer":"","disable-pagination":"","multi-sort":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }